import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app-style-five',
  templateUrl: './download-app-style-five.component.html',
  styleUrls: ['./download-app-style-five.component.scss']
})
export class DownloadAppStyleFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
